module.exports = __webpack_public_path__ + "static/media/國立臺灣大學學生逕行修讀博士學位辦法.f43c5385.pdf";